// Tiny stack so Dialog can manage z-index + Escape key for nested modals.
// Each Dialog instance registers a unique id on mount and gets a
// monotonically-increasing z. The Escape handler in Dialog only closes
// when its id is at the top of the stack.

let nextZ = 50;
const stack: symbol[] = [];

export function registerDialog(): { id: symbol; z: number } {
  const id = Symbol('dialog');
  nextZ += 10;
  stack.push(id);
  return { id, z: nextZ };
}

export function unregisterDialog(id: symbol): void {
  const i = stack.indexOf(id);
  if (i !== -1) stack.splice(i, 1);
  // Reset the counter when nothing's open so long sessions don't drift
  // toward huge z-index numbers. Cosmetic; never collides with anything.
  if (stack.length === 0) nextZ = 50;
}

export function isTopmostDialog(id: symbol): boolean {
  return stack[stack.length - 1] === id;
}
